import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  MenuItem,
  Checkbox,
  Autocomplete,
  Button,
} from "@mui/material";
import axios from "axios";
import baseUrl from "../../../config/baseUrl";
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';

const icon = <CheckBoxOutlineBlankOutlinedIcon fontSize="small" />;
const checkedIcon = <CheckBoxOutlinedIcon fontSize="small" />;

function SolutionsApply() {
  const auth = sessionStorage.getItem("user");
  const [countryName, setCountryName] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [modeOfSolution, setModeOfSolution] = useState([]);
  const [formState, setFormState] = useState({});

  const constantModes = [
    { value: '1', label: 'Card Processing' },
    { value: '2', label: 'Alternative Payment Modes (Deposit)' },
    { value: '10', label: 'Payout (Withdrawal)' },
    { value: '11', label: 'Settlement' },
    { value: '12', label: 'Batch Payout' }
  ];

  const handleModeChange = (event, selectedOptions) => {
    setModeOfSolution(selectedOptions.map(option => option.value));
  };

  const ReadData = async () => {
    try {
      const values = { tab: 2 };
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      };
      const result = await axios.post(`${baseUrl}/defaultBusinesSettingData`, values, config);
      if (result.data) {
        setFormState(result.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const merchantData = async () => {
    try {
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      };
      const result = await axios.post(`${baseUrl}/allCountries`, {}, config);
      setCountryName(result.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const values = {
        solution_apply_for_country: selectedCountries.map(c => c.value).join(','),
        mode_of_solution: modeOfSolution.join(','),
      };

      const config = {
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${auth}`,
        },
      };

      const result = await axios.post(`${baseUrl}/save-country-solution-apply`, values, config);
      alert(result.data.message);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    ReadData();
    merchantData();
  }, []);

  useEffect(() => {
    if (formState && countryName.length > 0) {
      // Ensure selectedCountries is set properly
      if (formState.solution_apply_for_country) {
        const selected = formState.solution_apply_for_country
          .split(',')
          .map(id => countryName.find(c => parseInt(c.value) === parseInt(id.trim())))
          .filter(Boolean);
        setSelectedCountries(selected);
      }
  
      // Ensure modeOfSolution is set properly
      if (formState.mode_of_solution) {
        const modes = formState.mode_of_solution.split(',').map(m => m.trim());
        setModeOfSolution(modes);
      }
    }
  }, [formState, countryName]); // Make sure these dependencies are set correctly
  
  

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          multiple
          options={constantModes}
          disableCloseOnSelect
          getOptionLabel={(option) => option.label || ""}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.label}
            </li>
          )}
          fullWidth
          renderTags={(value) =>
            value.length > 0 ? `${value.length} value(s) selected` : ""
          }
          value={constantModes.filter(mode => modeOfSolution.includes(mode.value))}
          onChange={handleModeChange}
          renderInput={(params) => (
            <TextField {...params} label="Mode of Solution" />
          )}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Autocomplete
          multiple
          options={countryName}
          disableCloseOnSelect
          getOptionLabel={(option) => option.label || ""}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.label}
            </li>
          )}
          fullWidth
          renderTags={(value) =>
            value.length > 0 ? `${value.length} value(s) selected` : ""
          }
          value={selectedCountries}
          onChange={(event, newValue) => setSelectedCountries(newValue)}
          renderInput={(params) => (
            <TextField {...params} label="Countries Solutions" />
          )}
        />
      </Grid>

      <Grid item xs={12}>
        <Button
          onClick={handleSave}
          variant="contained"
          color="success"
          size="medium"
          sx={{ float: "inline-end" }}
        >
          Save
        </Button>
      </Grid>
    </Grid>
  );
}

export default SolutionsApply;
